<template>
  <div class="convey-checkbox-group d-flex align-items-center gap-3">
    <div
      v-for="option in optionsList"
      :key="option.value"
      class="form-check form-switch"
    >
      <input
        v-model="option.checked"
        class="form-check-input"
        type="checkbox"
        role="switch"
        :id="`convey-checkbox-${option.value}`"
        :name="`convey-checkbox-${option.value}`"
        @change="changedOptions"
      />
      <label
        class="form-check-label text-capitalize fw-light fs-3"
        :for="`convey-checkbox-${option.value}`"
      >
        {{ option.text }}
      </label>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  name: "ConveyCheckboxGroup",
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    options: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      optionsList: [],
    };
  },
  created() {
    this.updateOptions();
  },
  methods: {
    updateOptions() {
      this.optionsList = this.options.map(option => {
        const checked = this.value.includes(option.value);
        return { ...option, checked };
      });
    },
    changedOptions($event) {
      const selectedValues = this.optionsList
        .filter(option => option.checked)
        .map(option => option.value);
      this.$emit('input', selectedValues);
    }
  },
  watch: {
    value: {
      handler() {
        this.updateOptions();
      },
      deep: true,
    },
    options: {
      value: {
        handler() {
          this.updateOptions();
        },
        deep: true,
      }
    },
  },
};
</script>

<style lang="scss">
.convey-checkbox-group {}
</style>
